import client from "../../../graphql/client";
import { loader } from "graphql.macro";
import { snackbarError, snackbarSuccess } from "shared/redux/actions/Snackbar";
import createErrorMessage from "helpers/createErrorMessage";
import { INSPECTION_REOPENED } from "redux/types";

const reopenBookInspection = loader("graphql/mutations/reopenBookInspection.graphql");

export default function inspectionReopen(inspectionId) {
    return async (dispatch) => {
        try {
            await client.mutate({ mutation: reopenBookInspection, variables: { inspectionId } });
            dispatch(snackbarSuccess("audit.inspection.reopened"));
            dispatch({
                type: INSPECTION_REOPENED,
                inspectionId
            });

        } catch (error) {
            console.error(error);
            dispatch(snackbarError(createErrorMessage(error)));
        }
    };
}
